<script setup lang="ts">
import { defineProps } from 'vue';

const props = withDefaults(
  defineProps<{
    large?: boolean;
  }>(),
  {
    large: false,
  }
);
</script>

<template>
  <svg v-if="props.large" width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L8 8L15 0.999999" stroke-linecap="round" stroke-linejoin="round" />
  </svg>

  <svg v-else width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4L5 7L8 4" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
